module.exports = __webpack_public_path__ + "img/santa_clara_seguros.b650450b.png";